import {
    differenceInDays,
    format,
    isToday,
    isYesterday
} from 'date-fns';
import {
    enUS,
    ru
} from 'date-fns/locale';

import { firstUpperCase } from '../../../utils/strings';

export const formatDateSmart = (date, locale) => {
    try {

        const inputDate = new Date(date);
        const today = new Date();
        const daysDiff = differenceInDays(today, inputDate);
        const localeObject = { locale: locale === 'en' ? enUS : ru };

        if (isToday(inputDate)) {
            return `${firstUpperCase(Object.R('titles.today'))}, ${format(inputDate, 'HH:mm', localeObject)}`;
        } else if (isYesterday(inputDate)) {
            return `${firstUpperCase(Object.R('titles.yesterday'))}, ${format(inputDate, 'HH:mm', localeObject)}`;
        } else if (daysDiff >= 0 && daysDiff <= 3) {
            return `${Object.R('titles.days', { days: daysDiff })}, ${format(inputDate, 'HH:mm', localeObject)}`;
        }
        return format(inputDate, 'dd MMMM yyyy, HH:mm', localeObject);
    } catch (e) {
        return Object.R('titles.unknownDate');
    }
};

export const formatFileSize = (size) => {
    if (size === null || size === undefined || isNaN(Number(size))) {
        return '0';
    }
    const bytes = Number(size);
    if (bytes < 0) {
        return '0';
    }
    if (bytes < 102400) { // 100 KB = 102400 bytes
        return `${(bytes / 1024).toFixed(2)} KB`;
    }
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

export const mergeObjectArraysByKey = (arr1, arr2, key) => {
    const map = new Map();
    arr1.forEach(item => map.set(item[key], item));
    arr2.forEach(item => map.set(item[key], item));
    return Array.from(map.values());
};
